import { hasAnyAccess } from "@/shared/security/model/has-any-access";
import { useUserProtectionTokens } from "@/shared/security/model/user-protection-tokens/use-user-protection-tokens";

/**
 * Пункт меню показывается, если хоть одно из требуемых прав что-нибудь разрешает. Записи здесь
 * нет и быть не может, поэтому спрашивается признак «есть ли доступ хоть к кому-нибудь» — той
 * же функцией, что и у гейтов страниц, чтобы меню и страница не разошлись в ответе.
 */
export function useFilterByPermissions() {
  const { tokens } = useUserProtectionTokens();

  const hasRequiredPermission = ({
    requiredAtLeastOnePermission,
  }: {
    requiredAtLeastOnePermission?: string[];
  }) => {
    if (!Array.isArray(requiredAtLeastOnePermission)) {
      return true;
    }

    return requiredAtLeastOnePermission.some((requiredTokenId) =>
      hasAnyAccess(tokens, requiredTokenId),
    );
  };

  return hasRequiredPermission;
}
